<template>
    <div class="scrollWrap smooth" :class="{'with-table-numbers' :  this.$signalR.tableNumbers.length, 'with-collect': showCollect, 'with-orders' : showOrders, 'with-units' : visibleRecieptUnits.length}">

        <!-----------------
        | PREPERATION
        ------------------>
        <div class="reciepts preperation" :class="{'showFuture' : showFuture, 'hideFuture' : !showFuture }" v-if="showReciepts">
            <span class="pendingreciepts-wrp">
                <Reciept v-for="order in preperationReciepts" :key="order.id" :AccentColor="order.accentColor" :Order="order" :Units="visibleRecieptUnits"></Reciept>
            </span>
            <span class="futurereciepts-wrp">
                <Reciept v-for="order in futurePreperationReciepts" :key="order.id" :AccentColor="order.accentColor" :Order="order" :Units="visibleRecieptUnits"></Reciept>
                <span class="scrolltoright on" v-if="futurePreperationReciepts.length >0" v-on:click="onPreperationRecieptScrollToRichtClick">
                    <span class="icon icon-jump icon-future"></span>
                    <span class="icon icon-jump icon-count">{{futurePreperationReciepts.length}}</span>
                </span>
            </span>
            <span class="scrolltoleft" v-if="recieptScrolled" v-on:click="onPreperationRecieptsScrolltoleftClick">
                <span class="icon icon-jump icon-arrow-circle-left"></span>
            </span>
            <div class="panel" v-if="!(preperationReciepts.length + futurePreperationReciepts.length)">
                <translate item="Timeline.NoOrdersYet" />
            </div>
        </div>

        <!-----------------
        | COLLECT & BONCHEF
        ------------------>
        <div class="reciepts collect bonchef" v-if="showCollect">
            <Reciept v-for="order in collectReciepts" :key="order.id" :AccentColor="order.accentColor" :Order="order" :Units="visibleCollectUnits"></Reciept>
            <div class="panel" v-if="!collectReciepts.length && !futurecollectReciepts.length">
                <translate item="Timeline.NoOrdersYet" />
            </div>

            <span class="futurecollectreciepts-wrp" :class="{'showFuture' : showFuture, 'hideFuture' : !showFuture }" v-if="futurecollectReciepts.length >0" v-on:click="onCollectRecieptScrollToRichtClick">

                <span class="expandToBottom on" >
                    <span class="icon icon-jump icon-future"></span>
                    <span class="icon icon-jump icon-count">{{futurecollectReciepts.length}}</span>
                </span>

                <Reciept v-for="order in futurecollectReciepts" :key="order.id" :AccentColor="order.accentColor" :Order="order" :Units="visibleCollectUnits"></Reciept>
            </span>

            <BonChef v-if="showBonChef" :Que="BonChefQue" :MarkerDate="MarkerDate"></BonChef>
         
        </div>


        <!-----------------
        | ORDERS
        ------------------>
        <div class="vert-scroll">
            <div class="timeline orders" v-if="showOrders">
                <RulerTicks :Markers="Markers" :ShiftDate="ShiftDate" :styleProp="styleProp" :MarkerDate="MarkerDate" :TickDistance="TickDistance"></RulerTicks>
                <div class="ruler-block">
                    <Order :styleProp="styleProp" v-for="order in visibleOrders" :key="order.id" :AccentColor="order.accentColor" :Order="order"></Order>
                </div>
                <div class="panel" v-if="!visibleOrders.length">
                    <translate item="Timeline.NoOrdersYet" />
                </div>
            </div>
        </div>

        <!-----------------
        | UNITS
        ------------------>
        <div class="vert-scroll">
            <div class="timeline units" v-if="visibleRecieptUnits.length">
                <RulerTicks :styleProp="styleProp" :Markers="Markers" :ShiftDate="ShiftDate" :MarkerDate="MarkerDate" :TickDistance="TickDistance"></RulerTicks>
                <div class="ruler-block">
                    <Unit :styleProp="styleProp" v-for="unit in visibleRecieptUnits" :key="unit.id" :AccentColor="unit.accentColor" :Unit="unit"></Unit>
                </div>
            </div>
        </div>


        <TableNumbers></TableNumbers>
        <Ruler :styleProp="styleProp" :ShowSlider="!showCollect" :ShiftDate="ShiftDate" :Markers="Markers" :MarkerDate="MarkerDate" :TickDistance="TickDistance" :BonChefs="BonChefQue"></Ruler>


        <ctx-menu :tag="'unit-active'" :list="cmListUnitActive" @ctxMenuItemClick="onCtxClick" :itemWidth="250" :itemHeight="43" :underline="true" :arrow="true">
        </ctx-menu>
        <ctx-menu :tag="'unit-inactive'" :list="cmListUnitInActive" @ctxMenuItemClick="onCtxClick" :itemWidth="250" :itemHeight="43" :underline="true" :arrow="true">
        </ctx-menu>

    </div>
</template>


<script>

    import Ruler from '../components/Ruler.vue';
    import RulerTicks from '../components/RulerTicks.vue';
    import Order from '../components/Order.vue';
    import Reciept from '../components/Reciept.vue';
    import BonChef from '../components/BonChef.vue';
   
    import Unit from '../components/Unit.vue';
    import timeStore from '../repositories/TimeManager';
    import ctxMenu from '../components/CtxMenu.vue';
    import configRepository from '../repositories/ConfigRepository';
    import bonchefRepository from '../repositories/BonchefRepository';
    import translate from '../components/translate'

    // Import the EventBus
    import { EventBus } from '../repositories/Eventbus';



    const TimeLine = {

        data: function () {
            return {
                //StartDate: timeStore.state.startTime,
                // EndDate: timeStore.state.endTime,//new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1, 0, 0, 0),
                Left: -3300,
                storeprop: timeStore.state,
                MarkerDate: new Date(),
                ShiftDate: null,
                Units: this.$signalR.units,
                TimeLineSettings: this.$signalR.timelineSettings,
                showOrders: this.$signalR.showOrders,
                showReciepts: this.$signalR.showReciepts,
                showCollect: this.$signalR.showCollect,
                showBonChef: this.$signalR.showBonChef,
                animateUseScroll: true,
                recieptScrolled: false,
                collectUnitGroupIds: [],
                showFuture: timeStore.state.timelineShowFuture,
                containsFutureOrders: false,
                cmListUnitActive: [{
                    text: 'Unit uitschakelen',
                    icon: 'icon icon-times',
                    cmd: 'disable-unit'
                }],
                cmListUnitInActive: [{
                    text: 'Unit inschakelen',
                    icon: 'icon icon-checkmark',
                    cmd: 'enable-unit'
                }],

                /*
                 * Example of nested command list
                cmList: [{
                    text: 'Verwijder bestelling',
                    icon: 'fa fa-trash',
                    cmd : 'deleteorder'
                }, {
                    text: 'Bestelling verbergen',
                    icon: 'iconfont icon-xiayishou'
                }, {
                    text: 'More',
                    children: [{
                        text: 'Download',
                        children: []
                    }, {
                        text: 'Report'
                    }, {
                        text: 'Other',
                        icon: 'iconfont icon-bofang',
                        children: [{
                            text: 'Other-1'
                        }, {
                            text: 'Other-2'
                        }, {
                            text: 'Other-3'
                        }]
                    }]
                }]*/
            }
        },

        methods: {

            setRulerToCurrentDate: function () {
                var _this = this;
                timeStore.setNow(new Date());
                _this.MarkerDate = timeStore.state.now;

                if (this.$signalR.timelineSettings.shiftSeconds > 0) {
                    _this.ShiftDate = new Date(_this.MarkerDate);
                    _this.ShiftDate.setSeconds(_this.ShiftDate.getSeconds() + this.$signalR.timelineSettings.shiftSeconds);
                } else {
                    _this.ShiftDate = null;
                }

                if (timeStore.state.autoScroll && !_this.autoscrolling) {

                    if (_this.$el.querySelector('.ruler') == null) {
                        // _this.autoscrolling = true;

                        // load order fix
                        window.setTimeout(function () { _this.setRulerToCurrentDate() }, 1000);
                        return;
                    }

                    let x = (timeStore.calculateXPosition(_this.MarkerDate) / 100) * _this.$el.querySelector('.ruler').offsetWidth;
                    _this.Left = -x + 720;


                    // orders: scroll to first order which is being preperated
                    var scrollTo = document.querySelector(".timelineWrap.accent1");

                    if (scrollTo) {
                        var y = scrollTo.getBoundingClientRect().top + window.pageYOffset - 80;

                        //scrollTo = scrollTo.previousElementSibling || scrollTo;
                        _this.autoscrolling = true;

                        window.scrollTo({ top: y, behavior: 'smooth' });

                        window.setTimeout(function () { timeStore.setAutoScroll(true); }, 500);
                        window.setTimeout(function () { timeStore.setAutoScroll(true); _this.autoscrolling = false; }, 1500);

                        // window.setTimeout(function () { timeStore.setAutoScroll(true); _this.autoscrolling = false; }, 500);
                        //scrollTo.scrollIntoView({ behavior: "smooth", block: "start" });
                    }





                    // reciepts: scroll to first order which is being preperated
                    //if (this.autoRecieptsScroll) {

                    //    var scrollPanel = document.querySelector(".reciepts.collect");

                    //    if (scrollPanel) {
                    //        var scrollToReciept = document.querySelector(".reciepts.collect .reciept");

                    //        if (scrollToReciept) {

                    //            var x = scrollToReciept.offsetLeft - 80;

                    //            scrollPanel.scrollTo({ left: x });

                    //            window.scrollTo({ top: y, behavior: 'smooth' });

                    //            // window.setTimeout(function () { timeStore.setAutoScroll(true); _this.autoscrolling = false; }, 500);
                    //            //scrollTo.scrollIntoView({ behavior: "smooth", block: "start" });
                    //        }
                    //    }
                    //} else {
                    //    // scroll after some time
                    //    if (this.autoRecieptsScrollCount++ > 1) {
                    //        this.autoRecieptsScrollCount = 0;
                    //        this.autoRecieptsScroll = true;
                    //    }
                    //}

                    this.determineFutureOrders();
                }

            },

            determineFutureOrders: function () {
              
                var futureOrders = false;

                // determine future orders
                this.$signalR.visibleOrders.forEach(function (order) {
                    futureOrders = timeStore.setOrderToFuture(order) || futureOrders;
                });

                this.containsFutureOrders = futureOrders;
            },

            onCtxClick: function (item) {
                switch (item.item.cmd) {
                    case 'disable-unit':
                        this.$signalR.setUnitState(item.target.unitGroupId, item.target.id, false);
                        break;
                    case 'enable-unit':
                        this.$signalR.setUnitState(item.target.unitGroupId, item.target.id, true);
                        break;
                }
            },

            onPreperationPreperationRecieptsScrolltoleftClick: function () {
                var scrollPanel = document.querySelector(".reciepts.preperation");
                if (scrollPanel) {
                    scrollPanel.scrollTo({ left: 0, behavior: 'smooth' });
                }
            },
            onPreperationRecieptScrollToRichtClick: function () {

               
                let newFutureState = !this.showFuture;
                this.setFutureState(newFutureState);

                var scrollPanel = document.querySelector(".reciepts.preperation");

                if (newFutureState) {
                    window.setTimeout(function () {
                        scrollPanel = document.querySelector(".reciepts.preperation");
                        var scrollTo = document.querySelector(".pendingreciepts-wrp");
                        if (scrollPanel) {
                            scrollPanel.scrollTo({ left: scrollTo.offsetWidth - (screen.availWidth / 2), behavior: 'smooth' });
                        }
                    }, 10);
                } else {
                    // no need to scroll.
                    if (scrollPanel.scrollLeft > 10) {
                        var scrollTo = document.querySelector(".pendingreciepts-wrp");
                        if (scrollPanel) {
                            scrollPanel.scrollTo({ left: (scrollTo.offsetWidth - screen.availWidth + 50), behavior: 'smooth' });
                        }
                    }
                }
            },
            onCollectRecieptScrollToRichtClick: function () {
                this.onPreperationRecieptScrollToRichtClick();

                if (this.showFuture) 
                    this.$nextTick(() => {
                        window.scrollBy({ top: 400, left: 0, behavior: 'smooth' });
                    });
                
                
            },
            setFutureState: function (newFutureState) {
                if (newFutureState) {
                    this.showFuture = newFutureState;
                    timeStore.setTimeLineShowFuture(this.showFuture);
                } else {
                    // no need to scroll.
                    this.showFuture = newFutureState;
                    timeStore.setTimeLineShowFuture(this.showFuture);
                }
            },

            recieptPanelOnScroll(recieptPanel) {

                if (recieptPanel.scrollLeft > 20) {
                    this.recieptScrolled = true;
                } else {
                    this.recieptScrolled = false;
                }
            }
        },

        computed: {

            StartDate() {
                return timeStore.state.startTime;
            },

            EndDate() {
                return timeStore.state.endTime;
            },

            TickDistance: function () {
                console.log(this.storeprop.zoom);
                if (this.storeprop.zoom > 8350) {
                    return 1;
                }

                if (this.storeprop.zoom > 5250) {
                    return 2;
                }

                if (this.storeprop.zoom > 1600) {
                    return 5;
                }
                if (this.storeprop.zoom > 1200) {
                    return 10;
                }

                if (this.storeprop.zoom > 500) {
                    return 15;
                }

                if (this.storeprop.zoom > 250) {
                    return 30;
                }

                if (this.storeprop.zoom > 100) {
                    return 60;
                }


                if (this.storeprop.zoom > 50) {
                    return 120;
                }

                //<50
                return 240;

            },

            visibleOrders: function () {
                var _this = this;
                window.setTimeout(function () {
                    document.querySelectorAll(".line").forEach(function (el) {
                        el.style.left = _this.Left + 'px';
                    });
                }, 20);
                                
                this.determineFutureOrders();
                return this.$signalR.visibleOrders;
            },

            visibleRecieptUnits: function () {
                return this.Units.filter(function (a) { return a.isVisible });
            },

            visibleCollectUnits: function () {
                var _this = this;
                if (_this.collectUnitGroupIds && _this.collectUnitGroupIds.length) {
                    return this.Units.filter(u => _this.collectUnitGroupIds.includes(u.id));
                }
            },

            /*
                  returns the reciepts for the collect view (inpakscherm)
              */
            collectReciepts: function () {

                var _this = this;
                if (_this.collectUnitGroupIds && _this.collectUnitGroupIds.length) {
                    return this.visibleOrders.filter(a => {
                        return a.fromHistorySearch || (!a.futurePending && a.batches && a.batches.some(b => {
                            return _this.collectUnitGroupIds.indexOf(b.unitGroupId) >= 0;
                        }));
                    });
                } else {
                    return this.visibleOrders.filter(a => {
                        return a.fromHistorySearch || !a.futurePending;
                    });
                }
            },
            futurecollectReciepts: function () {

                var _this = this;
                if (_this.collectUnitGroupIds && _this.collectUnitGroupIds.length) {
                    return this.visibleOrders.filter(a => {
                        return a.futurePending && (a.batches && a.batches.some(b => {
                            return _this.collectUnitGroupIds.indexOf(b.unitGroupId) >= 0;
                        }));
                    });
                } else {
                    return this.visibleOrders.filter(a => {
                        return a.futurePending;
                    });
                }
            },

            /**
             * Returns the the reciepts of the visible units, future and status 5 excluded.
             * */
            preperationReciepts: function () {

                var _this = this;

                // this.Orders.filter(a => { return a.status < 2 } )
                return this.visibleOrders.filter(a => {
                    return a.fromHistorySearch || (!a.futurePending && a.status < 4 && a.batches && a.batches.some(b => {
                        return _this.visibleRecieptUnits.some(c => { return c.id == b.unitGroupId });
                    }));
                });

            },

            /**
             * Returns all the reciepts of the visible units which are in the future
             * */
            futurePreperationReciepts: function () {

                var _this = this;

                // this.Orders.filter(a => { return a.status < 2 } )
                return this.visibleOrders.filter(a => {
                    return a.futurePending && a.status < 4 && a.batches && a.batches.some(b => {
                        return _this.visibleRecieptUnits.some(c => { return c.id == b.unitGroupId });
                    });
                });

            },

            styleProp: function () {
                let _style = {};
                _style.width = this.storeprop.zoom + '%';
                return _style;
            },

            // need annotation
            Markers: function () {

                let startDate = timeStore.state.startTime.getTime();// this.StartDate.getTime();
                let loopDate = startDate;
                let endDate = timeStore.state.endTime.getTime();
                let totalMilliseconds = timeStore.state.totalMilliseconds;// endDate - loopDate;
                let returnArray = [];

                while (loopDate < endDate) {
                    let date = new Date(loopDate);


                    returnArray.push({
                        x: (((loopDate - startDate) / totalMilliseconds) * 100),
                        date: date,
                        caption: date.toLocaleTimeString("nl-nl", { hour: "2-digit", minute: "2-digit" })

                        //caption: Intl.NumberFormat('nl-nl', { minimumIntegerDigits: 2, }).format(date.getHours()),
                        //caption2: Intl.NumberFormat('nl-nl', { minimumIntegerDigits: 2, }).format(date.getMinutes())

                    })

                    loopDate += this.TickDistance * 1000 * 60; // miliseconds * seconds * minutes = hour
                }

                return returnArray;
            },

            BonChefQue: function () {
                if (this.showBonChef)
                    return bonchefRepository.que;
                else
                    return [];
            },
        },

        watch: {
            "storeprop.zoom": function (newval, oldval) {
                // percentage changed
                var delta = newval / oldval;
                var centerpos = window.innerWidth / 2;
                var deltapx = centerpos - (centerpos * delta);

                this.Left = (this.Left * delta) + deltapx;
                this.storeprop.zoom = parseInt(this.storeprop.zoom);

                // disable the transition
                var el = document.querySelector('.scrollWrap.smooth');
                if (el) el.className = "scrollWrap";

                window.setTimeout(function () {
                    document.querySelector('.scrollWrap').className = "scrollWrap smooth";
                }, 10);

                this.storeprop.autoScroll = false;
                //this.setRulerToCurrentDate();
            },

            "storeprop.autoScroll": function () {
                this.setRulerToCurrentDate();
            },

            "TimeLineSettings.shiftSeconds": function () {
                this.setRulerToCurrentDate();
            },

            "Left": function () {
                var _this = this;
                document.querySelectorAll(".line, .ruler, .ticks").forEach(function (el) {
                    el.style.left = _this.Left + 'px';
                });
            }
        },

        mounted: function () {

            // the unit groups to show the collect orders from.
            this.collectUnitGroupIds = configRepository.getConfig().collectUnitGroupIds;

            if (configRepository.getConfig().showServe) {
                window.location = '/#serve';
            }

            var _this = this;
            var date = new Date();

            timeStore.setStartTime(new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1, 22, 0, 0));
            timeStore.setEndTime(new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1, 10, 0, 0));
            timeStore.setAutoScroll(true);

            function inOutQuad(n) {
                n *= 2;
                if (n < 1) return 0.5 * n * n;
                return - 0.5 * (--n * (n - 2) - 1);
            }

            function onMouseDown(e) {

                timeStore.setAutoScroll(false);

                _this.$el.classList.remove('smooth');

                var startX = e.clientX || e.touches[0].clientX;
                var startY = e.clientY || e.touches[0].clientY;
                var speedX = 0, speedY = 0;

                // var scrollRation = document.body.scrollHeight / window.innerHeight;


                function touchmove(e) {
                    var endX = e.clientX || e.touches[0].clientX;
                    var endY = e.clientY || e.touches[0].clientY;
                    speedX = (endX - startX);
                    speedY = (endY - startY);
                    window.scrollBy({ left: 0, top: -speedY, behavior: 'auto' });

                    _this.Left += (speedX);

                    //document.querySelectorAll(".line, .ruler, .ticks").forEach(function (el) {
                    //	el.style.left = _this.Left + 'px';
                    //});


                    startX = endX;
                    startY = endY;
                    e.preventDefault();

                }

                function mouseup() {

                    _this.$el.classList.add('smooth');

                    if (Math.abs(speedX) > 10) {
                        _this.Left += speedX * 30;
                    }

                    document.removeEventListener("touchmove", touchmove)
                    document.removeEventListener("touchend", mouseup);
                    document.removeEventListener("mousemove", touchmove)
                    document.removeEventListener("mouseup", mouseup);

                    // becouse the touch event is canceled, the document scrolling is disabled.
                    // we use requestanimationframe to scroll the document with a bit of easing
                    var stop = false;
                    var startx = -speedY;
                    var destx = 0;
                    var duration = 1000;
                    var start = null;

                    function startAnim(timeStamp) {
                        start = timeStamp;
                        //  end = start + duration;
                        animate(timeStamp);
                    }

                    function animate(now) {
                        if (stop) return;
                        if (now - start >= duration) stop = true;
                        var p = (now - start) / duration;
                        var val = inOutQuad(p);
                        var x = startx + (destx - startx) * val;
                        window.scrollBy({ left: 0, top: x, behavior: 'auto' });
                        requestAnimationFrame(animate);
                    }
                    requestAnimationFrame(startAnim);


                }

                if (e.touches) {
                    document.addEventListener("touchmove", touchmove, { passive: false });
                    document.addEventListener("touchend", mouseup);
                }
                else {
                    document.addEventListener("mousemove", touchmove);
                    document.addEventListener("mouseup", mouseup);
                }

            }

            this.$el.querySelectorAll('.vert-scroll').forEach(a => a.addEventListener("mousedown", onMouseDown));
            this.$el.querySelectorAll('.vert-scroll').forEach(a => a.addEventListener("touchstart", onMouseDown));

            this.setRulerToCurrentDate();

            window.setInterval(function () {
                _this.setRulerToCurrentDate();
            }, 1000 * 10);

            var scrollPanel = document.querySelector(".reciepts.preperation");
            if (scrollPanel) {
                scrollPanel.addEventListener('scroll', function () {
                    _this.recieptPanelOnScroll(scrollPanel);
                });
            }

            document.querySelectorAll(".line, .ruler, .ticks").forEach(function (el) {
                el.style.left = _this.Left + 'px';
            });

            EventBus.$on('scroll-x-to', function (order) {
                timeStore.setAutoScroll(false);
                let x = (timeStore.calculateXPosition(order.startDate) / 100) * _this.$el.querySelector('.ruler').offsetWidth;
                _this.Left = -x + 720;
            });


        },

        components: { Ruler, Order, Unit, Reciept, ctxMenu, RulerTicks, BonChef, translate }
    };

    export { TimeLine as default };


</script>
